import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { PermissaoService } from 'src/app/shared/permissao.service';



@Component({
    selector: 'app-ipoc-envio',
    templateUrl: './ipoc-envio.component.html',
    standalone: false
})
export class IpocEnvioComponent implements OnInit {

  titulo = 'Envio de lotes de ocorrências';
  instrucoesEnvio = 'Envie um arquivo com as inclusões de IPOC, trocas de IPOC e alterações de dados retroativos de operações com outorga de garantia.';
  tipoConteudoArquivo = TipoConteudo.ATUALIZACAO_SCR;
  textoBtnArquivoExemplo = "Exemplo de arquivo em formato CSV";
  tipoArquivoExemplo = "Ação IPOC";

  constructor(protected injector: Injector,
    //protected service: IpocService,
    private permissaoService: PermissaoService,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }
}
